import React from "react";
import { useField } from "../Form/useField";
import { TypeaheadSelect, Suggestion } from "../../components";

type Props = {
  label: string;
  isDisabled?: boolean;
  id: string;
  className?: string;
  placeholder: string;
  name: string;
  required?: boolean;
  defaultValue?: any;
  getSelectedValue?: (selected: null | { label: string; value: any }) => any;
  getValueDisplay: (value: any) => string;
  suggestions: Suggestion[];
};

const SelectField: React.FC<Props> = ({
  label,
  id,
  className,
  placeholder,
  name,
  required,
  suggestions,
  getSelectedValue = selected => selected,
  getValueDisplay,
  defaultValue = null
}) => {
  const { value, onChange } = useField({ name, required, defaultValue });

  return (
    <TypeaheadSelect
      className={className}
      id={id}
      label={label}
      onChange={selected => {
        onChange(getSelectedValue(selected));
      }}
      placeholder={placeholder}
      suggestions={suggestions}
      value={getValueDisplay(value)}
    />
  );
};

export default SelectField;
